import { Gender, RacialDenomination, MandatoryWorkflowField } from '../types';
import { WavelightData } from '../views/workflow/types';

export const checkUnfilledFields = (
  data: WavelightData,
): MandatoryWorkflowField[] => {
  const unfilledFields: MandatoryWorkflowField[] = [];

  if (!data.video) unfilledFields.push(MandatoryWorkflowField.VIDEO_INPUT);
  if (!(data.person.age > 0))
    unfilledFields.push(MandatoryWorkflowField.AGE_INPUT);
  if (data.person.gender === Gender.UNDEFINED)
    unfilledFields.push(MandatoryWorkflowField.GENDER_INPUT);
  if (!(data.person.height > 0))
    unfilledFields.push(MandatoryWorkflowField.HEIGHT_INPUT);
  if (data.person.racialDenomination === RacialDenomination.UNDEFINED)
    unfilledFields.push(MandatoryWorkflowField.RACIAL_DENOMINATION_INPUT);
  if (!(data.person.weight > 0))
    unfilledFields.push(MandatoryWorkflowField.WEIGHT_INPUT);

  return unfilledFields;
};

export const prettifyWorkflowField = (field: MandatoryWorkflowField) => {
  switch (field) {
    case MandatoryWorkflowField.AGE_INPUT:
      return 'Idade';
    case MandatoryWorkflowField.GENDER_INPUT:
      return 'Gênero';
    case MandatoryWorkflowField.HEIGHT_INPUT:
      return 'Altura';
    case MandatoryWorkflowField.RACIAL_DENOMINATION_INPUT:
      return 'Denominação racial';
    case MandatoryWorkflowField.VIDEO_INPUT:
      return 'Vídeo';
    case MandatoryWorkflowField.WEIGHT_INPUT:
      return 'Peso';
  }
};
